const middleware = {}

middleware['pageContent'] = require('../middleware/pageContent.js')
middleware['pageContent'] = middleware['pageContent'].default || middleware['pageContent']

export default middleware
